<template>
<v-layout row>
<v-flex xs12>
    <h1>Billing</h1>
    <v-flex xs12>
        <button @click="test">test</button>
    <v-card class="elevation-4 mt-4">
    <v-data-table
        :headers="headers"
        :items="drafts"
        :loading="ui.loading"
        :rows-per-page-items="ui.rowsPerPageItems"
        no-data-text="There are no currently pending drafts that require billing."
        class="elevation-0"
    >
        <v-progress-linear slot="progress" :color="isDark ? 'white' : 'primary'" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
            <tr @click="draftDetails(props)" class="pointer" :class="{'grey darken-4 white--text': isDark && (draft && draft.id === props.item.id && props.item.customer.last_name !== true), 'primary white--text': !isDark && (draft && draft.id === props.item.id && props.item.customer.last_name !== true), 'red darken-4 white--text': props.item.billing_previously_declined }">
            <td>{{ props.item.customer.first_name }} {{ props.item.customer.last_name }}</td>
            <td>{{ props.item.customer.email }}</td>
            <td>{{ calculateItemQuantity(props.item.line_items) }}</td>
            <td>${{ props.item.total_price }}</td>
            <td>{{ props.item.is_delivered_timestamp | toDate }}</td>
            <td>{{ daysSince(props.item.is_delivered_timestamp) }}</td>
            <td class="text-xs-center" :class="{'white--text': !isDark && props.item.billing_previously_declined}">
                <v-icon :class="{'box-card-icon': props.expanded}" v-if="props.item.is_returning">check</v-icon>
            </td>
            <td class="text-xs-center" :class="{'white--text': !isDark && props.item.billing_previously_declined}">
                <v-icon :class="{'box-card-icon': props.expanded}" v-if="props.item.is_returned">check</v-icon> 
            </td>
            </tr>
        </template>

        <template slot="expand" slot-scope="props">
          <v-layout column>
            <v-card>
            <v-flex xs12 v-if="draft">
                <v-tabs
                v-model="ui.tab"
                :dark="isDark"
                :light="!isDark"
                fixed-tabs
                grow
                slider-color="transparent"
                >
                <v-tab ripple :style="{'background': isDark && (ui.tab === 1 || ui.tab === 2 || ui.tab === 3) ? '#303030!important' : !isDark && (ui.tab === 1 || ui.tab === 2 || ui.tab === 3) ? '#E0E0E0!important' : 'transparent'}">
                Bill
                </v-tab>
                <v-tab ripple :style="{'background': isDark && (ui.tab === 0 || ui.tab === 2 || ui.tab === 3) ? '#303030!important' : !isDark && (ui.tab === 0 || ui.tab === 2 || ui.tab === 3) ? '#E0E0E0!important' : 'transparent'}">
                Draft
                </v-tab>
                <v-tab ripple :style="{'background': isDark && (ui.tab === 0 || ui.tab === 1 || ui.tab === 3) ? '#303030!important' : !isDark && (ui.tab === 0 || ui.tab === 1 || ui.tab === 3) ? '#E0E0E0!important' : 'transparent'}">
                Tracking
                </v-tab>
                <v-tab ripple :style="{'background': isDark && (ui.tab === 0 || ui.tab === 1 || ui.tab === 2) ? '#303030!important' : !isDark && (ui.tab === 0 || ui.tab === 1 || ui.tab === 2) ? '#E0E0E0!important' : 'transparent'}">
                Subscription
                </v-tab>
                
                <v-tab-item>
                    <v-card flaT>
                        <v-data-table
                            :headers="line_item_headers"
                            :items="draft.line_items"
                            :loading="ui.loading"
                            class="elevation-0"
                            :rows-per-page-items="ui.rowsPerPageItems"
                            hide-actions
                        >
                        <template slot="items" slot-scope="line_items">
                          <tr>
                            <td>{{ line_items.item.title }}</td>
                            <td>{{ line_items.item.sku }}</td>
                            <td class="text-xs-center">{{ line_items.item.quantity }}</td>
                            <td>${{ line_items.item.price }}</td>
                          </tr>
                        </template>
                        <template slot="footer">
                            <tr width="100%">
                                <td>
                                    <strong>Sub Total</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td><strong>{{calculatedDraftSubTotal}}</strong></td>
                            </tr>
                            <tr width="100%" :class="{'no-discount': draft.is_returned}">
                                <td>
                                    <strong>No Return Discount</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td class="text-xs-center"><strong style="margin-right:5px;">-15%</strong></td>
                            </tr>
                            <tr width="100%">
                                <td>
                                    <strong>Total</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td><strong>{{calculatedDraftTotal}}</strong></td>
                            </tr>
                        </template>
                        </v-data-table>

                        <v-flex xs12 v-if="draft.billing_previously_declined" class="pa-3 text-align-center red darken-4" :class="{'white--text': !isDark}">
                            On <span class="font-weight-bold">{{draft.billing_previously_declined_timestamp | toTimestamp}}</span> the previous billing attempt was declined by authorize.net for this given reason:
                            <span class="font-weight-bold">{{draft.billing_previously_declined_reason}}</span>
                        </v-flex>

                        <v-flex xs12 v-if="billing_error" class="pa-3 text-align-center red darken-4" :class="{'white--text': !isDark}">
                            There was a billing error: {{billing_error.error_message}}
                        </v-flex>

                        <v-flex xs12>
                            <v-btn @click="billCustomer" :loading="ui.loading" large block class="pa-0 ma-0" :class="{'primary white--text': !isDark}">Bill for {{calculatedDraftTotal}}</v-btn>
                        </v-flex>

                    </v-card>
                </v-tab-item>

                <v-tab-item>
                    <v-card flat v-if="draft">
                    <v-card-text>
                        <v-container grid-list-sm fluid class="ma-0 pa-0">
                        <v-layout row wrap>
                            <v-flex xs12 sm8>
                            <v-layout row wrap>
                                <v-flex xs12 sm6><v-text-field label="First Name" :value="draft.customer.first_name" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm6><v-text-field label="Last Name" :value="draft.customer.last_name" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12><v-text-field label="Email" :value="draft.customer.email" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12><v-text-field label="Address" :value="draft.customer.default_address.address1" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12><v-text-field label="Address 2" :value="draft.customer.default_address.address2" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm4><v-text-field label="City" :value="draft.customer.default_address.city" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm4><v-text-field label="State" :value="draft.customer.default_address.province" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm4><v-text-field label="Zip" :value="draft.customer.default_address.zip" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12><v-text-field label="Country" :value="draft.customer.default_address.country" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12 v-if="draft.customer.default_address.phone"><v-text-field label="Phone" :value="draft.customer.default_address.phone" box readonly hide-details></v-text-field></v-flex>
                            </v-layout>
                            </v-flex>
                            <v-flex xs12 sm4>
                            <v-list class="pt-0 subscriber-details" style="background:transparent!important;">
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Draft ID</v-list-tile-title>
                                    <v-list-tile-sub-title>{{draft.id}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Box ID</v-list-tile-title>
                                    <v-list-tile-sub-title>{{draft.box_id}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Subscription Product</v-list-tile-title>
                                    <v-list-tile-sub-title>{{draft.subscription_product.title}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Created At</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ draft.created_at | toTimestamp }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Shipped At</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ draft.is_shipped_timestamp | toTimestamp }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Is Returned?</v-list-tile-title>
                                    <v-list-tile-sub-title>{{draft.is_returned === true ? 'Yes' : 'No'}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="draft.is_returned">
                                <v-list-tile-content>
                                    <v-list-tile-title>Return Date</v-list-tile-title>
                                    <v-list-tile-sub-title>{{draft.is_returned_timestamp | toTimestamp}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="draft.is_returned">
                                <v-list-tile-content>
                                    <v-list-tile-title>Is Full Return?</v-list-tile-title>
                                    <v-list-tile-sub-title>{{draft.is_full_return === true ? 'Yes' : 'No'}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                            </v-flex>

                            <v-flex xs12 class="mt-2">
                                <h4>Kept Items</h4>
                                <v-data-table
                                    :headers="line_item_headers"
                                    :items="draft.line_items"
                                    :loading="ui.loading"
                                    class="elevation-1 mt-2"
                                    hide-actions
                                >
                                <template slot="items" slot-scope="line_items">
                                <tr>
                                    <td>{{ line_items.item.title }}</td>
                                    <td>{{ line_items.item.sku }}</td>
                                    <td class="text-xs-center">{{ line_items.item.quantity }}</td>
                                    <td>${{ line_items.item.price }}</td>
                                </tr>
                                </template>
                                </v-data-table>
                            </v-flex>
                            <v-flex xs12 v-if="draft.returns" class="mt-2">
                                <h4>Returned Items</h4>
                                <v-data-table
                                    :headers="line_item_headers"
                                    :items="draft.returns"
                                    :loading="ui.loading"
                                    class="elevation-1 mt-2"
                                    hide-actions
                                >
                                <template slot="items" slot-scope="line_items">
                                <tr>
                                    <td>{{ line_items.item.title }}</td>
                                    <td>{{ line_items.item.sku }}</td>
                                    <td class="text-xs-center">{{ line_items.item.quantity }}</td>
                                    <td>${{ line_items.item.price }}</td>
                                </tr>
                                </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item>
                    <v-card flat>
                    <v-card-text>
                        <v-layout row wrap>
                        <v-flex xs12 sm6>
                        <h3>Shipment</h3><span v-if="!ui.loading && draft.draft_shipment_tracking">Tracking Code: {{draft.draft_shipment_tracking_code}}<br>
                        <span v-if="draft.draft_shipment_tracking.est_delivery_date">Estimated Arrival: {{draft.draft_shipment_tracking.est_delivery_date | toTimestamp}}</span></span>
                        <v-timeline
                        v-if="!ui.loading && draft.draft_shipment_tracking"
                        align-top
                        dense                  
                        >
                        <v-timeline-item
                            v-for="(detail, i) in draft.draft_shipment_tracking.tracking_details"
                            :key="i"
                            small
                            :color="isDark ? 'white' : 'primary'"
                        >
                            <v-layout pt-3>
                            <v-flex xs3>
                                <strong>{{detail.datetime | toDate}}<br>{{detail.datetime | toTime}}</strong>
                            </v-flex>
                            <v-flex>
                                <strong>{{detail.message}}</strong>
                                <div class="caption">{{detail.tracking_location.city}} {{detail.tracking_location.state}} {{detail.tracking_location.zip}}
                                </div>
                            </v-flex>
                            </v-layout>
                        </v-timeline-item>
                        </v-timeline>
                        </v-flex>

                        <v-flex xs12 sm6>
                        <h3>Return Shipment</h3><span v-if="!ui.loading && draft.draft_return_tracking">Tracking Code: {{draft.draft_return_tracking_code}}<br>
                        <span v-if="draft.draft_return_tracking.est_delivery_date">Estimated Arrival: {{draft.draft_return_tracking.est_delivery_date | toTimestamp}}</span></span>
                        <v-timeline
                        v-if="!ui.loading && draft.draft_return_tracking"
                        align-top
                        dense                  
                        >
                        <v-timeline-item
                            v-for="(detail, i) in draft.draft_return_tracking.tracking_details"
                            :key="i"
                            small
                            :color="isDark ? 'white' : 'primary'"
                        >
                            <v-layout pt-3>
                            <v-flex xs3>
                                <strong>{{detail.datetime | toDate}}<br>{{detail.datetime | toTime}}</strong>
                            </v-flex>
                            <v-flex>
                                <strong>{{detail.message}}</strong>
                                <div class="caption">{{detail.tracking_location.city}} {{detail.tracking_location.state}} {{detail.tracking_location.zip}}
                                </div>
                            </v-flex>
                            </v-layout>
                        </v-timeline-item>
                        </v-timeline>
                        </v-flex>
                        </v-layout>
                    </v-card-text>
                    </v-card>
                </v-tab-item>
                
                <v-tab-item>
                    <v-card flat v-if="subscription">
                    <v-card-text>
                        <v-container grid-list-sm fluid class="ma-0 pa-0">
                        <v-layout row wrap>
                            <v-flex xs12 sm8>
                            <v-layout row wrap>
                                <v-flex xs12 sm6><v-text-field label="First Name" :value="subscription.customer.first_name" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm6><v-text-field label="Last Name" :value="subscription.customer.last_name" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12><v-text-field label="Email" :value="subscription.customer.email" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12><v-text-field label="Address" :value="subscription.customer.default_address.address1" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12><v-text-field label="Address 2" :value="subscription.customer.default_address.address2" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm4><v-text-field label="City" :value="subscription.customer.default_address.city" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm4><v-text-field label="State" :value="subscription.customer.default_address.province" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm4><v-text-field label="Zip" :value="subscription.customer.default_address.zip" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12><v-text-field label="Country" :value="subscription.customer.default_address.country" box readonly hide-details></v-text-field></v-flex>
                                <v-flex xs12 sm12 v-if="subscription.customer.default_address.phone"><v-text-field label="Phone" :value="subscription.customer.default_address.phone" box readonly hide-details></v-text-field></v-flex>
                            </v-layout>
                            </v-flex>
                            <v-flex xs12 sm4>
                            <v-list class="pt-0 subscriber-details" style="background:transparent!important;">
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Account ID</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.customer.id}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Subscription ID</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.id}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Subscription Product</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.product.title}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Subscription SKU</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.variant.sku}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Subscription Start</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.subscription_start | toTimestamp}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-if="subscription.subscription_end">
                                <v-list-tile-content>
                                    <v-list-tile-title>Subscription End</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.subscription_end | toTimestamp}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Last Box Date</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.last_box_date | toTimestamp}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Boxes Sent</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.last_subscription_box_month}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Has Draft</v-list-tile-title>
                                    <v-list-tile-sub-title>{{subscription.has_draft ? 'Yes' : 'No'}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-card-text>
                    </v-card>
                </v-tab-item>
                </v-tabs>
            </v-flex>
            </v-card>
          </v-layout>
        </template>
    </v-data-table>
    </v-card>
    </v-flex>
</v-flex>
</v-layout>

</template>

<script>
import { db, functions } from '@/services/firebase.js'
import moment from 'moment'

export default {
    data () {
        return {
            ui: {
                loading: true,
                dialog: false,
                discount: false,
                tab: null,
                rowsPerPageItems: [25, 50, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }]
            },
            headers: [
                { text: 'Name', align: 'left', value: 'name' },
                { text: 'Email', value: 'email' },
                { text: 'Items', value: 'line_items' },
                { text: 'Worth', value: 'total_price' },
                { text: 'Delivered', value: 'delivered' },
                { text: 'Days', value: 'days_since_delivered', width: 10 },
                { text: 'Returning?', value: 'is_returning', width: 10 },
                { text: 'Returns?', value: 'is_returned', width: 10 }
            ],
            line_item_headers: [
                { text: 'Item', align: 'left', value: 'title' },
                { text: 'SKU', value: 'sku', width: 200 },
                { text: 'Qty', value: 'quantity', width: 20 },
                { text: 'Price', value: 'price', width: 20 }
            ],
            products: [],
            drafts: [],
            subscription: null,
            draft: null,
            details: null,
            billing_error: null
        }
    },
    filters: {
        toDate: function(str){
            return moment(str).format('MM/DD/YY')
        },
        toTime: function(str){
            return moment(str).format('hh:mm:ss A')
        },
        toTimestamp: function(str){
            return moment(str).format('MM/DD/YY hh:mm:ss A')
        },
        toOunces: function(grams) {
            return Math.ceil(grams * 0.0352739619)
        }
    },
    computed: {
        isAdmin () {
            return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
        },
        isManager () {
            return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
        },
        isDark: function () {
            return this.$vuetify.dark
        },
        calculatedDraftSubTotal: function () {
            var self = this
            if(self.draft){
                var total = 0
                self.draft.line_items.forEach((item) => {
                    total = total + (parseFloat(item.price) * item.quantity)
                })
                return '$' + total.toFixed(2)
            } else {
                return '$0.00'
            }
        },
        calculatedDraftTotal: function () {
            var self = this
            if(self.draft){
                var total = 0
                self.draft.line_items.forEach((item) => {
                    total = total + (parseFloat(item.price) * item.quantity)
                })
                if (!self.draft.is_returned) {
                    total = total - (total * 0.15)
                    return '$' + total.toFixed(2)
                } else {
                    return '$' + total.toFixed(2)
                }
            } else {
                return '$0.00'
            }
        }
    },
    methods: {
      daysSince: function (timestamp) {
        return moment(Date.now()).diff(moment(timestamp), 'days')
      },
      calculateItemQuantity: function (line_items) {
        var total = 0
        line_items.forEach((item) => {
            total = total + item.quantity
        })
        return total
      },
      draftDetails: function (draft) {
        var self = this

        draft.expanded = !draft.expanded

        if (draft.expanded) {
            self.ui.loading = true

            self.billing_error = null
        
            self.draft = null
            self.draft = draft.item

            self.draft.subscription_product = self.products.find((product) => product.id === self.draft.subscription_product_id)

            self.getSubscription(self.draft.subscription_id)

            if (self.draft.draft_shipment_tracking_code) {
                self.getDraftShipmentTracking(self.draft.draft_shipment_tracking_code)
                .then(() => {
                    if (self.draft.draft_return_tracking_code) {
                        self.getDraftReturnTracking(self.draft.draft_return_tracking_code)
                        .then(() => {
                            self.ui.loading = false
                        })
                        .catch((e) => {
                            console.error(e)
                            self.ui.loading = false
                        })
                    } else {
                        self.ui.loading = false
                    }
                })
                .catch((e) => {
                    console.error(e)
                    self.ui.loading = false
                })
            } else {
                self.ui.loading = false
            }
        }
      },
      getSubscription: function (subscription_id) {
        var self = this
        self.ui.loading = true
        return new Promise((resolve, reject) => {
            db.collection("subscriptions").doc(subscription_id.toString()).get()
            .then((subscription_doc) => {
                let subscription = subscription_doc.data()
                subscription.product = self.products.find((product) => product.id === subscription.subscription_product_id)
                subscription.variant = subscription.product.variants.find((variant) => variant.id === subscription.subscription_product_variant_id)
                self.subscription = subscription
                self.ui.loading = false
                resolve()
            })
            .catch((err) => {
                console.error(err)
                self.ui.loading = false
                reject()
            })
        })
      },
      getDraftShipmentTracking: function (tracking_number) {
        var self = this
        return new Promise((resolve, reject) => {
            db.collection('tracking').doc(tracking_number).get()
            .then((doc) => {
                let tracking = doc.data()
                self.draft.draft_shipment_tracking = tracking
                resolve()
            })
            .catch((err) => {
                console.error(err)
                reject()
            })
        })
      },
      getDraftReturnTracking: function (tracking_number) {
        var self = this
        return new Promise((resolve, reject) => {
            db.collection('tracking').doc(tracking_number).get()
            .then((doc) => {
                let tracking = doc.data()
                self.draft.draft_return_tracking = tracking
                resolve()
            })
            .catch((err) => {
                console.error(err)
                reject()
            })
        })
      },
      billCustomer: function () {
        var self = this
        self.billing_error = null
        self.ui.loading = true

        var billCustomer = functions.httpsCallable('chargeCustomerForDraft')
        billCustomer({
            draft_id: self.draft.id.toString(),
            subscription_id: self.draft.subscription_id.toString(),
            is_returned: self.draft.is_returned,
            vault_id: self.subscription.vault_id,
            payment_profile_id: self.subscription.payment_profile_id
        })
        .then((result) => {
          console.log(result.data)
          try {
            if (result.data.sucesss === true) {
                self.ui.loading = false
                self.$root.$emit('event', {type: 'info', event: 'Subscriber was successfully billed for: ' + self.draft.id})

            } else {
                self.billing_error = result.data.error
                self.ui.loading = false
                self.$root.$emit('event', {type: 'error', event: 'Subscriber was not successfully billed for: ' + self.draft.id})
            }
          }
          catch (e) {
              console.error(e)
              self.ui.loading = false
              self.$root.$emit('event', {type: 'error', event: 'Subscriber was not successfully billed for: ' + self.draft.id + '. Check the console.'})
          }
        })
        .catch((err) => {
            console.error(err)
            self.$root.$emit('event', {type: 'error', event: 'Subscriber was not successfully billed for: ' + self.draft.id})
            self.ui.loading = false
        })
      },
      test: function () {
          const self = this
          self.$root.$emit('event', {type: 'error', event: 'test'})
      }
    },
    created () {
        var self = this

        // add timestamp filtering so it will only show drafts that were delivered great than 7 days ago

        db.collection('drafts')
        .where('status', '==', 'open')
        .where('is_delivered', '==', true)
        .where('is_billed', '==', false)
        .onSnapshot((draftSnapshot) => {
            var pending = []
            draftSnapshot.forEach((draft) => {
                pending.push(draft.data())
            })
            // console.log(pending)
            self.drafts = pending
            self.ui.loading = false
        })
        db.collection('products').onSnapshot(productsSnapshot => {
          var products = []
          productsSnapshot.forEach(function(doc) {
              products.push(doc.data())
          })
          self.products = products
        })
    },
    mounted () {

    }
}
</script>

<style lang="stylus" scoped>
.application .theme--dark .v-card
  .box-card-toolbar, .box-card-background
    background #212121!important
.box-card-toolbar, .box-card-background
  background-color #212121!important
.no-discount
    text-decoration line-through
    color #CCCCCC
.list-pointer
  cursor pointer
  transition all 0.75 ease
.error
  color #FFFFFF!important
  .v-btn
    color #FFFFFF!important
.application .theme--dark-old .v-card, .theme--dark-old .v-card
  background-color #40525b!important
  .box-card-toolbar-old
    background-color #0D2029!important
  .box-card-background-old
    background-color #1d2935!important
.theme--dark-old .v-card
  background #0D2029!important
  background-color #0D2029!important
.no-hover.v-btn.v-btn--icon.v-btn--small::before
  opacity: 0!important
.theme--dark-old .variant-table table
  background #0D2029!important
  background-color #0D2029!important
  font-size 20px!important
.application .theme--light .v-card, .theme--light .v-card
  .box-card-toolbar
    background-color #1976d2!important
    color #FFFFFF!important
    font-weight 500!important
  .box-card-background
    background-color #FFFFFF!important
    color #FFFFFF!important
  .box-card-icon
    background-color transparent!important
    color #FFFFFF!important
</style>